import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { BASE_SUFFIXES } from '../translation-suffixes';
import { PartialsHelpersService } from '../partials-helpers.service';
import { CardComponent } from '../../../shared/components/card/card.component';
import { SideBySideComponent } from '../../../shared/components/side-by-side/side-by-side.component';

@Component({
    selector: 'vision2-section-0',
    imports: [
        CommonModule,
        PipesModule,
        TranslateModule,
        CardComponent,
        SideBySideComponent,
    ],
    templateUrl: './section-0.component.html',
    styleUrl: './section-0.component.scss',
})
export class Section0Component implements OnChanges {
    @Input() productData: any;
    groupedContent: Record<string, any[]> = {};
    hasValidTranslations = false;

    constructor(private helpers: PartialsHelpersService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.getTranslations();
    }

    getTranslations(): void {
        this.groupedContent = {
            'SECTION-0_SIDE-BY-SIDE': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-0_SIDE-BY-SIDE',
                BASE_SUFFIXES,
                [0, 1],
            ),
            //Content Blocks
            'SECTION-0_CONTENT-BLOCK': this.helpers.translateContentGroup(
                this.productData,
                'SECTION-0_CONTENT-BLOCK',
                BASE_SUFFIXES,
                [0, 1],
            ),
        };

        this.hasValidTranslations = this.helpers.hasValidTranslation(
            this.groupedContent,
        );
    }

    hasTranslationValues(groupedContent: any[]): boolean {
        if (!groupedContent || groupedContent.length === 0) {
            return false;
        }

        return groupedContent.some(
            (item) => item.imageUrl || item.descriptionText || item.headingText,
        );
    }
}
